<template>
  <div v-if="items">
    <el-table :data="items" style="width: 100%">
      <el-table-column label="申请时间" width="150">
        <template #default="scope">
          {{ scope.row.createdDate }}
        </template>
      </el-table-column>
      <el-table-column label="发票金额" width="120" align="center">
        <template #default="scope">￥{{ scope.row.amount.toFixed(2) }}</template>
      </el-table-column>
      <el-table-column label="发票类型" width="180">
        <template #default="scope">
          <span v-if="!scope.row.isVatSpecial && scope.row.isElectronic">增值税普通发票（数电）</span>
          <span v-else-if="scope.row.isVatSpecial && scope.row.isElectronic">增值税专用发票（数电）</span>
          <span v-else-if="!scope.row.isVatSpecial && !scope.row.isElectronic">增值税普通发票（纸质）</span>
          <span v-else-if="scope.row.isVatSpecial && !scope.row.isElectronic">增值税专用发票（纸质）</span>
        </template>
      </el-table-column>
      <el-table-column label="发票抬头">
        <template #default="scope">
          {{ scope.row.taxTitle }}
        </template>
      </el-table-column>
      <el-table-column label="状态" width="120" align="center">
        <template #default="scope">
          {{ getInvoiceStatus(scope.row.status) }}
        </template>
      </el-table-column>
      <el-table-column label="备注" align="center">
        <template #default="scope">
          {{ scope.row.memo }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="120">
        <template #default="scope">
          <el-link
            type="primary"
            style="margin-right: 5px"
            :underline="false"
            @click.prevent="btnViewClick(scope.row)"
          >
            查 看
          </el-link>
        </template>
      </el-table-column>
    </el-table>

    <el-drawer title="发票信息" direction="rtl" size="60%" v-if="invoice" v-model="isInvoice">
      <div
        class="el-table el-table--fit el-table--enable-row-hover el-table--enable-row-transition"
        style="width: 100%; margin: 0 15px"
      >
        <div class="el-table__body-wrapper is-scrolling-none">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" width="100%">
            <colgroup>
              <col width="180" />
              <col />
            </colgroup>
            <tbody>
              <tr class="el-table__row">
                <td rowSpan="1" colSpan="1">
                  <div class="cell">
                    <strong>申请时间</strong>
                  </div>
                </td>
                <td rowSpan="1" colSpan="1">
                  <div class="cell">
                    {{ invoice.createdDate }}
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowSpan="1" colSpan="1">
                  <div class="cell">
                    <strong>状态</strong>
                  </div>
                </td>
                <td rowSpan="1" colSpan="1">
                  <div class="cell">
                    {{ getInvoiceStatus(invoice.status) }}
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowSpan="1" colSpan="1">
                  <div class="cell">
                    <strong>发票金额</strong>
                  </div>
                </td>
                <td rowSpan="1" colSpan="1">
                  <div class="cell">￥{{ invoice.amount.toFixed(2) }}</div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowSpan="1" colSpan="1">
                  <div class="cell">
                    <strong>发票类型</strong>
                  </div>
                </td>
                <td rowSpan="1" colSpan="1">
                  <div class="cell">
                    <span v-if="!invoice.isVatSpecial && invoice.isElectronic">增值税普通发票（数电）</span>
                    <span v-else-if="invoice.isVatSpecial && invoice.isElectronic">增值税专用发票（数电）</span>
                    <span v-else-if="!invoice.isVatSpecial && !invoice.isElectronic">增值税普通发票（纸质）</span>
                    <span v-else-if="invoice.isVatSpecial && !invoice.isElectronic">增值税专用发票（纸质）</span>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowSpan="1" colSpan="1">
                  <div class="cell">
                    <strong>发票抬头</strong>
                  </div>
                </td>
                <td rowSpan="1" colSpan="1">
                  <div class="cell">{{ invoice.taxTitle }}</div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td rowSpan="1" colSpan="1">
                  <div class="cell">
                    <strong>纳税人识别号</strong>
                  </div>
                </td>
                <td rowSpan="1" colSpan="1">
                  <div class="cell">
                    {{ invoice.taxNo }}
                  </div>
                </td>
              </tr>
              <template v-if="invoice.isVatSpecial">
                <tr class="el-table__row">
                  <td rowSpan="1" colSpan="1">
                    <div class="cell">
                      <strong>注册地址</strong>
                    </div>
                  </td>
                  <td rowSpan="1" colSpan="1">
                    <div class="cell">{{ invoice.taxAddress }}</div>
                  </td>
                </tr>
                <tr class="el-table__row">
                  <td rowSpan="1" colSpan="1">
                    <div class="cell">
                      <strong>电话</strong>
                    </div>
                  </td>
                  <td rowSpan="1" colSpan="1">
                    <div class="cell">
                      {{ invoice.taxTel }}
                    </div>
                  </td>
                </tr>
                <tr class="el-table__row">
                  <td rowSpan="1" colSpan="1">
                    <div class="cell">
                      <strong>开户银行</strong>
                    </div>
                  </td>
                  <td rowSpan="1" colSpan="1">
                    <div class="cell">
                      {{ invoice.taxBankName }}
                    </div>
                  </td>
                </tr>
                <tr class="el-table__row">
                  <td rowSpan="1" colSpan="1">
                    <div class="cell">
                      <strong>银行帐号</strong>
                    </div>
                  </td>
                  <td rowSpan="1" colSpan="1">
                    <div class="cell">
                      {{ invoice.taxBankNo }}
                    </div>
                  </td>
                </tr>
              </template>
              <template v-if="invoice.isElectronic">
                <tr class="el-table__row">
                  <td rowSpan="1" colSpan="1">
                    <div class="cell">
                      <strong>电子邮箱</strong>
                    </div>
                  </td>
                  <td rowSpan="1" colSpan="1">
                    <div class="cell">
                      {{ invoice.email }}
                    </div>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr class="el-table__row">
                  <td rowSpan="1" colSpan="1">
                    <div class="cell">
                      <strong>收件人姓名</strong>
                    </div>
                  </td>
                  <td rowSpan="1" colSpan="1">
                    <div class="cell">
                      {{ invoice.deliveryName }}
                    </div>
                  </td>
                </tr>
                <tr class="el-table__row">
                  <td rowSpan="1" colSpan="1">
                    <div class="cell">
                      <strong>收件人电话</strong>
                    </div>
                  </td>
                  <td rowSpan="1" colSpan="1">
                    <div class="cell">
                      {{ invoice.deliveryTel }}
                    </div>
                  </td>
                </tr>
                <tr class="el-table__row">
                  <td rowSpan="1" colSpan="1">
                    <div class="cell">
                      <strong>快递地址</strong>
                    </div>
                  </td>
                  <td rowSpan="1" colSpan="1">
                    <div class="cell">
                      {{ invoice.deliveryAddress }}
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <div class="el-table__column-resize-proxy" style="display: none"></div>
      </div>
    </el-drawer>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { IInvoice, IOrder } from '@/types/models';
import api from '@/api/my/invoices';

const $statusDefault = 'Default';
const $statusDelivered = 'Delivered';
const $statusCancellation = 'Cancellation';

interface IState {
  items: IInvoice[];
  isInvoice: boolean;
  invoice?: IInvoice;
  order?: IOrder;
}

export default defineComponent({
  name: 'ListInvoice',
  data() {
    return {
      items: [],
      isInvoice: false,
      invoice: undefined,
      order: undefined,
    } as IState;
  },
  methods: {
    getInvoiceStatus(status: string) {
      if (status === $statusDefault) {
        return '待开发票';
      }
      if (status === $statusDelivered) {
        return '已寄出';
      }
      if (status === $statusCancellation) {
        return '作废发票';
      }
      return '待开发票';
    },

    btnResourceClick(order: IOrder) {
      if (order.resourceType === 'Service') {
        window.open('/vip/#pricing');
      }
    },

    btnViewClick(invoice: IInvoice) {
      this.invoice = invoice;
      this.isInvoice = true;
    },
  },
  mounted() {
    api.get(
      {
        isApply: false,
      },
      (res) => {
        if (!res) return;
        this.items = res.items;
      },
    );
  },
});
</script>
